export function getUserMachineTime() {
  const options = { hour12: true, hour: "numeric", minute: "numeric" };
  const userMachineTime = new Date()
    .toLocaleTimeString("en-US", options)
    .toLowerCase();

  return userMachineTime;
}
